
// 手机号
export function checkMobile (mobile: string) {
  return /^1(0|1|2|3|4|5|6|7|8|9)\d{9}$/.test(mobile)
}

// 密码
export function checkPassword (password: string) {
  return /^[A-Za-z0-9]{6,20}$/.test(password)
}

// 验证码
export function checkVcode (vcode: string) {
  return /^[0-9]{4}$/.test(vcode)
}